import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || 'https://api.noxpn.site';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Добавляем токен к запросам
api.interceptors.request.use(config => {
  const token = localStorage.getItem('vpn_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Обрабатываем ошибки
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      const hadToken = Boolean(localStorage.getItem('vpn_token'));
      localStorage.removeItem('vpn_token');
      if (hadToken) {
        window.dispatchEvent(new Event('vpn:unauthorized'));
      }
    }
    return Promise.reject(error);
  }
);

export default api;
